<template>
  <div class="account-page login-modern">
    <div class="account-content">
      <div class="login-wrapper login-centered">
        <div class="login-content">
          <VForm
            @submit="onSubmit"
            :validation-schema="schema"
            v-slot="{ errors }"
          >
            <div class="login-userset">
              <div class="login-logo logo-normal">
                <img src="@/assets/img/logo.png" alt="img" />
              </div>
              <router-link to="/dashboard" class="login-logo logo-white">
                <img src="@/assets/img/logo-white.png" alt="" />
              </router-link>
              <p class="brand-tagline">
                NEDAM FACTURA | Solution de gestion des factures
              </p>
              <div class="login-userheading">
                <h4>
                  Accédez au plateforme en utilisant votre e-mail et votre mot
                  de passe.
                </h4>
              </div>
              <div
                class="emailshow text-danger align-center font-14"
                id="email"
              ></div>
              <div class="form-login mb-3">
                <label class="form-label">Adresse Email</label>
                <div class="form-addons">
                  <VField
                    name="email"
                    type="text"
                    class="form-control"
                    :class="{ 'is-invalid': errors.email }"
                  />
                  <div class="invalid-feedback">{{ errors.email }}</div>
                  <img src="@/assets/img/icons/mail.svg" alt="img" />
                </div>
              </div>
              <div class="form-login mb-3">
                <label class="form-label">Mot de Passe</label>
                <div class="pass-group">
                  <VField
                    name="password"
                    :type="showPassword ? 'text' : 'password'"
                    class="form-control pass-input mt-2"
                    :class="{ 'is-invalid': errors.password }"
                  />
                  <span @click="toggleShow" class="toggle-password">
                    <i
                      :class="{
                        'fas fa-eye': showPassword,
                        'fas fa-eye-slash': !showPassword,
                      }"
                    ></i>
                  </span>
                  <div class="invalid-feedback">{{ errors.password }}</div>
                  <div class="emailshow text-danger" id="password"></div>
                </div>
              </div>
              <div class="form-login">
                <button type="submit" class="btn btn-login">
                  SE CONNECTER
                </button>
              </div>
              <div class="signinform mt-3">
                <h6>
                  <router-link to="/signup" class="hover-a">Demander un accès (préinscription)</router-link>
                </h6>
              </div>
            </div>
          </VForm>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { ref } from "vue";
import { router } from "@/router";
import { Form as VForm, Field as VField } from "vee-validate";
import * as Yup from "yup";
import { login, getCurrentUser } from "@/services/authService";
import { toast } from "vue3-toastify";
export default {
  components: {
    VForm,
    VField,
  },
  data() {
    return {
      showPassword: false,
      password: null,
      emailError: "",
      passwordError: "",
    };
  },
  computed: {
    buttonLabel() {
      return this.showPassword ? "Hide" : "Show";
    },
  },
  methods: {
    toggleShow() {
      this.showPassword = !this.showPassword;
    },
  },
  setup() {
    const schema = Yup.object().shape({
      email: Yup.string()
        .required("Email is required")
        .email("Email is invalid"),
      password: Yup.string()
        .min(6, "Password must be at least 6 characters")
        .required("Password is required"),
    });
    const onSubmit = async (values) => {
      document.getElementById("email").innerHTML = "";
      document.getElementById("password").innerHTML = "";
      try {
        const response = await login({
          email: values.email,
          password: values.password,
          password_confirmation: values.password,
        });
        const payload = getCurrentUser();
        const roleFromResponse = response?.user?.role?.role;
        const role = roleFromResponse || payload?.role;
        const targetRoute =
          role === "Dev" ? "/support/pending-societes" : "/dashboard";
        router.push(targetRoute);
      } catch (error) {
        document.getElementById("email").innerHTML =
          "Email ou Mot de passe est invalide";
        const message =
          error?.response?.data?.message || "Une erreur est survenue";
        toast.error(message);
      }
    };
    return {
      schema,
      onSubmit,
      checked: ref(false),
    };
  },
};
</script>
<style scoped>
/* Typography Hierarchy */
.brand-tagline {
  font-size: 12px;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: #6b7280;
  text-align: center;
  margin: 12px 0 24px;
  line-height: 1.4;
}

.login-userheading h4 {
  font-size: 15px;
  font-weight: 400;
  color: #475569;
  line-height: 1.5;
  margin-bottom: 24px;
}

.form-login label {
  font-size: 13px;
  font-weight: 500;
  color: #334155;
  margin-bottom: 6px;
}

.form-login input {
  font-size: 14px;
  color: #1e293b;
}

.btn-login {
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.03em;
}

.signinform h6 {
  font-size: 13px;
  font-weight: 500;
  color: #64748b;
  text-align: center;
}

.signinform a {
  font-size: 13px;
  font-weight: 500;
  color: #142d4b;
  text-decoration: none;
  transition: color 0.2s;
}

.signinform a:hover {
  color: #2563eb;
  text-decoration: underline;
}

.invalid-feedback,
.emailshow {
  font-size: 12px;
}

/* Layout */
.login-modern {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #142d4b 0%, #fe9e4224 100%);
  padding: 32px 16px;
  position: relative;
  overflow: hidden;
}

.login-modern::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: 
    url("data:image/svg+xml,%3Csvg width='100' height='100' viewBox='0 0 100 100' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23ffffff' fill-opacity='0.03'%3E%3Cpath d='M20 10h20v20H20zM60 10h20v20H60zM20 50h20v20H20zM60 50h20v20H60z'/%3E%3C/g%3E%3C/svg%3E");
  opacity: 0.5;
}

.login-modern::after {
  content: '';
  position: absolute;
  width: 600px;
  height: 600px;
  background: radial-gradient(circle, rgba(255,159,67,0.15) 0%, transparent 70%);
  top: -200px;
  right: -200px;
  border-radius: 50%;
  animation: float 20s ease-in-out infinite;
}

@keyframes float {
  0%, 100% {
    transform: translate(0, 0) scale(1);
  }
  50% {
    transform: translate(-30px, 30px) scale(1.1);
  }
}

.login-modern .account-content {
  width: 100%;
  position: relative;
  z-index: 1;
}

.login-modern .login-wrapper {
  width: 100%;
  height: auto;
  min-height: auto;
  display: flex;
  align-items: center;
  justify-content: center;
}

.login-wrapper.login-centered {
  background: transparent;
}

.login-wrapper.login-centered .login-content {
  width: 100%;
  max-width: 500px;
  height: auto;
  padding: 40px 48px;
  border-radius: 18px;
  background: #ffffff;
  box-shadow: 0 30px 60px rgba(15, 23, 42, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 2;
}

.login-wrapper.login-centered .login-userset {
  width: 100%;
  max-width: 360px;
  margin: 0 auto;
}

.login-wrapper.login-centered .form-login input {
  height: 44px;
  border-radius: 10px;
  padding: 0 14px;
}

.login-wrapper.login-centered .form-login .btn-login {
  border-radius: 10px;
  height: 46px;
  margin-top: 10px;
}

.login-wrapper.login-centered .login-logo img {
  max-height: 52px;
  margin-bottom: 4px;
}

.login-wrapper.login-centered .logo-white {
  display: none;
}

/* Responsive */
@media (max-width: 575px) {
  .login-modern {
    padding: 24px 12px;
  }

  .login-wrapper.login-centered .login-content {
    padding: 32px 24px;
  }

  .login-wrapper.login-centered .login-userset {
    max-width: 100%;
  }

  .login-modern::after {
    width: 400px;
    height: 400px;
    top: -150px;
    right: -150px;
  }

  .brand-tagline {
    font-size: 11px;
    margin: 10px 0 20px;
  }

  .login-userheading h4 {
    font-size: 14px;
    margin-bottom: 20px;
  }

  .form-login label {
    font-size: 12px;
  }

  .form-login input {
    font-size: 13px;
    height: 42px;
  }

  .btn-login {
    font-size: 13px;
    height: 44px;
  }

  .signinform h6,
  .signinform a {
    font-size: 12px;
  }

}
</style>
